module.exports = "<p-growl [(value)]=\"msgs\"></p-growl>\n<h3>Module</h3>\n\n<p *ngFor=\"let mod of modules\">\n  <label for=\"mod{{mod.id}}\">{{mod.name}}</label>\n  <p-inputSwitch inputId=\"mod{{mod.id}}\" [(ngModel)]=\"mod.active\" (onChange)=\"onChangeSwitch($event)\"></p-inputSwitch>\n</p>"


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/modules/modules.component.html
// module id = ../../../../../src/app/modules/modules.component.html
// module chunks = main